import { sva } from '@landr/styled-system/css';

export const creator = sva({
    slots: [
        'wrapper',
        'creator',
        'trigger',
        'header',
        'content',
        'scrollable',
        'placeholder',
        'image',
    ],
    base: {
        wrapper: {
            position: 'fixed',
            bottom: 0,
            width: '100%',
            zIndex: 'subOverlay',
            paddingBottom: 'env(safe-area-inset-bottom, 0)',
            backgroundColor: 'bg.medium',
        },
        creator: {
            paddingX: 0,
            border: 'none',
            userSelect: 'none',
            _last: {
                overflow: 'hidden',
            },
            '& > div': {
                gap: 0,
            },
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            position: 'relative',
            paddingX: 'sm',
            margin: 0,
            fontSize: 0,
            lineHeight: 1,
            borderBottom: '1px solid',
            borderColor: 'border.medium',
        },
        scrollable: {
            overflowX: 'hidden',
            overflowY: 'auto',
            maxHeight: 'calc(80vh - {sizes.lg})',
            padding: 0,
            '& > .simplebar-scrollbar:before': {
                backgroundColor: 'surface.inverted',
            },
        },
        content: {
            margin: '0 auto',
            padding: 0,
            _focusVisible: {
                outline: 'none',
            },
        },
        placeholder: {
            height: '132px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        },
        image: {
            height: '75px',
        },
    },
    variants: {
        isVisible: {
            true: {
                wrapper: {
                    display: 'block',
                },
            },
            false: {
                wrapper: {
                    display: 'none',
                },
            },
        },
        isSmall: {
            true: {
                image: {
                    height: '45px',
                },
            },
        },
    },
});
